export enum QuotationMapSupplierStatus {
  PENDING = 'Aguardando',
  RESPONDED = 'Respondido'
}

export interface QuotationMapSupplier {
  id: string;
  offerId: string;
  companyName: string;
  status: QuotationMapSupplierStatus;
  respondedAt: string;
  validity: string;
  price: number;
  /**
   * Preço cotado original quando o comprador negociou e mandou para aprovação: o backend grava o
   * negociado como `price` e guarda o cotado no `oldPrice` do produto.
   */
  originalPrice?: number | null;
  selected: boolean;
  negotiatedPrice?: number | null;
  negotiatedSelected?: boolean;
  bestPrice?: boolean;
  observations?: string | null;
  paymentMethod?: string | null;
  paymentTerms?: string | null;
  email?: string;
  link?: string;
  notParticipating?: boolean;
  cnpj?: string;
  phone?: string;
  suggestedPending?: boolean;
  /** Id do vínculo fornecedor↔oferta, usado para aprovar/rejeitar a sugestão. */
  ofertaFornecedorId?: string;
  source?: string;
  /** true quando o fornecedor não tem nenhum produto APROVADO (só sugestões PENDENTE). */
  isOnlyPendingSuggestion?: boolean;
}
